import api from '@api'
import { addAlert } from '@features/alerts'

const altPaymentFinalizeZipOrder = ({
  finalizationId,
  // minorUnits,
  // currencyCode,
  total,
  orderReference,
  orderId,
  recipientPhone,
  recipientEmail,
  sendReceipt,
  locationId: locationIdOverride,
  tenderTypesAbilityId,
  passOnFeeEnabled,
}) => async (dispatch, getState) => {
  const {
    business: { locationId: locationIdStore },
  } = getState()

  const locationId = locationIdOverride || locationIdStore

  await api
    .post(`/v1/locations/${locationId}/payments`, {
      locationId,
      finalizationId: finalizationId,
      orderReference,
      total,
      recipientPhone,
      recipientEmail,
      sendReceipt,
      orderId,
      tenderTypesAbilityId,
      passOnFeeEnabled,
    })
    .then(response => {
      if (response.data.paymentStatus === 'PAID') {
        return dispatch(
          addAlert({
            message: `Payment succeeded`,
            success: true,
            dismiss: true,
            top: true,
          })
        )
      } else {
        return dispatch(
          addAlert({
            message: response.data.error ?? `Payment declined`,
            error: true,
            dismiss: true,
            top: true,
          })
        )
      }
    })
    .catch(err => {
      const errMsg = err?.response?.data?.error
      if (errMsg) return dispatch(addAlert({ message: errMsg, error: true, dismiss: true, top: true }))
      else return dispatch(addAlert({ message: `Payment failed.`, error: true, dismiss: true, top: true }))
    })
}
export default altPaymentFinalizeZipOrder
